import { createApp } from 'vue'
import App from './App.vue'

// v0.0.5
createApp(App).mount('#app')
